import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Button,
    Snackbar,
    Alert,
    Fade,
    Divider,
} from "@mui/material";
import loginbg from "../assets/images/test2.jpg"
import textBg from "../assets/images/textBg.svg"
import logo from "../assets/images/logo/logo.png"
import CustomInputBox from "../components/customInputBox/CustomInputBox";
import { Email } from '@mui/icons-material';
import { useLocation } from "react-router-dom";
import { Auth } from "aws-amplify";
import { useNavigate, Link } from "react-router-dom";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import LoadingButton from '@mui/lab/LoadingButton';
import NewLogo from "../assets/images/logo/NewLogo.png";
import packageJson from '../../package.json'
import { showWarningSnackbar } from "../components/snackBar/snakbar";


const ForgotPassword = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('md'));

    let navigate = useNavigate();

    let location = useLocation();
    let params = location.state;
    //console.log(params)

    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        userMail: "",
        open: false,
        errorStatus: {
            userMail: false,
        },
        errorFields: {
            userMail: "",
            open: ""
        }
    });

    let horizontal = matches ? 'center' : 'left';
    let vertical = matches ? 'top' : 'bottom';

    const closeSnackbar = () => {
        setState((prev) => ({
            ...prev,
            open: false,
            errorFields: {
                ...prev.errorFields,
                open: ''
            }
        }))
    }

    const onChangeEvent = (event) => {
        const { name, value } = event.target;
        setState(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const handleFormSubmission = (event) => {

        // event.preventDefault();

        const { userMail } = state;

        const formData = {
            userMail: userMail
        }

        if (formValidation(formData)) {
            setLoading(true);
            confirmUserEmail(formData)

        }
    }

    async function confirmUserEmail(values) {
        const username = values.userMail
        try {
            // Send confirmation code to user's email
            await Auth.forgotPassword(username)
                .then(data => {
                    localStorage.setItem('startTime', new Date());
                    navigate("/newpassword", { state: { email: username } });

                    setState((prev) => ({
                        ...prev,
                        open: false,
                        errorFields: {
                            ...prev.errorFields,
                            open: ''
                        }
                    }))
                    setLoading(false);
                })
                .catch(error => {
                    showWarningSnackbar("The user either did not sign up with us or used a Google account to sign up")
                });

        } catch (error) {
            setLoading(false);

            console.log("error : ", error)

        }
    }

    const formValidation = (data) => {
        const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        let isvalid = true;

        Object.keys(data).map(itemKey => {

            if (itemKey === "userMail") {
                if (data[itemKey].trim().length <= 0) {
                    isvalid = false
                    setState(prev => ({
                        ...prev,
                        errorStatus: {
                            ...prev.errorStatus,
                            [itemKey]: true
                        },
                        errorFields: {
                            ...prev.errorFields,
                            [itemKey]: "Email is Required"
                        }
                    }))
                } else if (!regex.test(data[itemKey])) {
                    isvalid = false
                    setState(prev => ({
                        ...prev,
                        errorStatus: {
                            ...prev.errorStatus,
                            [itemKey]: true
                        },
                        errorFields: {
                            ...prev.errorFields,
                            [itemKey]: "Invalid email address"
                        }
                    }))
                } else {
                    isvalid = true
                    setState(prev => ({
                        ...prev,
                        errorStatus: {
                            ...prev.errorStatus,
                            [itemKey]: false
                        },
                        errorFields: {
                            ...prev.errorFields,
                            [itemKey]: ""
                        }
                    }))
                }
            }

        });

        return isvalid;

    }

    return (
        <Fade in={true}>

            <Box sx={{
                // display: "flex",
                // flexDirection: {
                //     xs: 'column',
                //     md: 'row'
                // },
                // alignItems: {
                //     xs: 'center',
                //     md: 'normal'
                // },
                // justifyContent: {
                //     xs: 'center',
                //     md: 'normal'
                // },
                // backgroundImage: {
                //     xs: `url(${loginbg})`,
                //     md: 'none'
                // },
                backgroundRepeat: "no-repeat",
                backgroundSize: "auto 100%",
                backgroundImage: `url(${loginbg})`,
                backgroundColor: "#e7e7e7",
                width: '100%',
                height: "100vh",
                // minHeight: "100vh",
                padding: {
                    xs: '20px 20px',
                    sm: '30px 40px',
                    md: '0px 0px'
                },
                boxSizing: 'border-box',
            }}>

                {/* {!matches ?
                    <Box sx={{
                        // flex : 1,
                        backgroundImage: `url(${loginbg})`,
                        backgroundSize: "auto 100%",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "left",
                        width: "55%",
                        height: "100vh",
                        display: "flex",
                        // justifyContent : "center",
                        alignItems: "center",
                        paddingLeft: "60px",
                        paddingRight: "60px",
                    }}>

                        <Box sx={{
                            height: {
                                md: "290px",
                                lg: "270px"
                            },
                            width: "100%",
                            // backgroundImage: `url(${textBg})`,
                            backgroundSize: "auto 100%",
                            backgroundRepeat: "no-repeat",
                            position: "relative",
                        }}>
                            <Box sx={{
                                position: "absolute",
                                left: 50,
                                top: 35,
                            }}>

                                <Typography variant="h4" sx={{ color: "black", marginBottom: "15px" }}>
                                    Confirmation <span style={{ fontWeight: "bold" }}>screen</span>
                                </Typography>

                                <Typography sx={{ color: "#3A3A3A", marginBottom: "30px", minWidth: "500px", maxWidth: "750px" }}>
                                    LedgerX is an accounting software specially designed to solve the daily business needs of a well established organization,
                                    You can review your daily entries and store bills in the cloud.
                                </Typography>

                                <Box sx={{
                                    backgroundColor: "#75428C",
                                    maxWidth: "240px",
                                    padding: "5px 15px",
                                    textAlign: "center",
                                    borderRadius: "20px"
                                }}>

                                    <Link component="Typography" style={{ textDecoration: 'none', color: '#fff' }} to='/login'>
                                        Login to Access Dashboard
                                    </Link>

                                </Box>

                            </Box>

                        </Box>

                    </Box>
                    :
                    <Box sx={{
                        width: {
                            xs: '90%',
                            sm: '80%',
                            md: '45%',
                            lg: '45%'
                        },
                        marginBottom: {
                            xs: '30px',
                            sm: '60px',
                            md: '0px'
                        }
                    }}>

                        <Typography variant="h4" sx={{
                            color: "black",
                            marginBottom: "15px",
                            textAlign: {
                                xs: 'center',
                                md: 'left'
                            }
                        }}>
                            Welcome to <span style={{ fontWeight: "bold" }}>Ledger</span>
                        </Typography>

                        <Typography sx={{
                            color: "3A3A3A", marginBottom: "15px",
                            textAlign: {
                                xs: 'center',
                                md: 'left'
                            }
                        }}>
                            LedgerX is an accounting software specially designed to solve the daily business needs of an well established organization,
                            You can review your daily entries and store bills in the cloud.
                        </Typography>

                        <Box
                            sx={{
                                backgroundColor: "#75428C",
                                maxWidth: "240px",
                                padding: "12px 15px",
                                textAlign: "center",
                                borderRadius: "20px",
                                margin: {
                                    xs: '0px auto',
                                    md: '0px'
                                }
                            }}

                        >

                            <Link component="Typography" style={{ textDecoration: 'none', color: '#fff' }} to='/login'>
                                Login to Access Dashboarde
                            </Link>

                        </Box>

                    </Box>
                } */}



                <Box sx={{
                    backgroundColor: "rgba(29, 14, 33, 0.75)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    // background: {
                    //     xs: "transparent",
                    //     md:"transparent",
                    //     lg: "#e7e7e7"
                    // },
                    width: "100%",
                    height: "100vh",
                    paddingLeft: {
                        xs: '0px',
                        // md: "30px"
                    },
                    paddingRight: {
                        xs: '0px',
                        // md: "30px"
                    },
                }}>

                    {/* Toast */}
                    <Snackbar open={state.open} autoHideDuration={6000} anchorOrigin={{ horizontal, vertical }} onClose={closeSnackbar}  >
                        <Alert onClose={closeSnackbar} variant="filled" severity="error" sx={{ width: '100%' }}>
                            {state.errorFields.open}
                        </Alert>
                    </Snackbar>

                    <Box sx={{

                        width: "800px",
                        // boxShadow: "0 5px 15px rgb(0, 0, 0 , 5%)",
                        boxShadow: "rgba(0, 0, 0, 0.25) 0px 4px 4px 0px",
                        padding: "40px",
                        paddingBottom: "20px",
                        background: '#f7f7f7',
                        borderRadius: '30px'
                    }}>

                        <Box sx={{ textAlign: 'center', marginBottom: "10px" }}>
                            <div
                                class="image"
                                style={{
                                    height: "80px",
                                    maxWidth: "250px",
                                    backgroundImage: `url(${NewLogo})`,
                                    backgroundSize: "250px",
                                    backgroundPosition: 'center',
                                    backgroundRepeat: "no-repeat",
                                    margin: '0 auto',
                                }}
                            >
                            </div>
                            <Divider sx={{ margin: "5px auto", width: "50%" }} />
                        </Box>

                        <Typography sx={{ color: "#75428C", display: "flex", justifyContent: "center", fontSize: "30px", fontFamily: "Overpass", fontWeight: "600" }}>
                            Enter Your e-mail
                        </Typography>

                        <CustomInputBox
                            name='userMail'
                            placeholder='Enter Your Email'
                            type='email'
                            autoFocus={true}
                            onChange={(e) => {
                                const { name, value } = e.target;
                                if (value == '') {
                                    setState(prev => ({
                                        ...prev,
                                        [name]: value,
                                        errorStatus: {
                                            ...prev.errorStatus,
                                            [name]: true
                                        },
                                        errorFields: {
                                            ...prev.errorFields,
                                            [name]: 'Email is Required'
                                        }
                                    }))
                                } else if (!/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(value)) {
                                    setState(prev => ({
                                        ...prev,
                                        [name]: value,
                                        errorStatus: {
                                            ...prev.errorStatus,
                                            [name]: true
                                        },
                                        errorFields: {
                                            ...prev.errorFields,
                                            [name]: 'Invalid Email Address'
                                        }
                                    }))
                                } else {
                                    setState(prev => ({
                                        ...prev,
                                        [name]: value,
                                        errorStatus: {
                                            ...prev.errorStatus,
                                            [name]: false
                                        },
                                        errorFields: {
                                            ...prev.errorFields,
                                            [name]: ''
                                        }
                                    }))
                                }
                            }}
                            state={state}
                            icon={<Email sx={{ color: (state.errorStatus.userMail === true) ? "danger.main" : "#8a8787" }} className="icon" />}
                        />

                        <Box sx={{
                            display: "flex", justifyContent: 'space-around', marginBottom: "20px",
                            // width:"90%",
                            margin: "5px auto"
                        }}>
                            <Box sx={{ flex: 1, textAlign: 'left' }}>
                                <Button variant='outlined'
                                    sx={{ width: 160, height: 50 }}
                                    onClick={(() => { navigate("/login") })}
                                >Cancel</Button>
                            </Box>
                            {/* <Button variant="contained" disableRipple={true} onClick= {(event) => handleFormSubmission(event)}> Submit </Button> */}
                            <Box sx={{ flex: 1, textAlign: 'right' }}>
                                <LoadingButton style={{ width: 160, height: 50 }} loading={loading} disableRipple={true} variant="contained" onClick={(event) => handleFormSubmission(event)}>
                                    Submit
                                </LoadingButton>
                            </Box>

                        </Box>
                        <Box sx={{ textAlign: "center", paddingTop: "10px" }}>
                            <Typography color={"grey"} >
                                Version {packageJson.version}
                            </Typography>
                        </Box>

                    </Box>

                </Box>

            </Box>
        </Fade>

    );

};

export default ForgotPassword;